import React from 'react';
import { useAffectedMeteredEvents } from '../../../../../../hooks/requests/use-affected-metered-events';
import { AffectedMeteredEventsTable } from './affected-metered-events-table';

type AffectedMeteredEventsProps = {
  eventRef: string;
  startTime?: Date;
  endTime?: Date;
};

export const AffectedMeteredEvents: React.FC<AffectedMeteredEventsProps> = ({
  eventRef,
  startTime,
  endTime,
}) => {
  const { data: affectedMeteredEventsResponse, isFetching: isFetchingAffected } = useAffectedMeteredEvents({
    eventRef,
    startTime,
    endTime,
  });

  const affectedMeteredEvents = affectedMeteredEventsResponse?.affectedMeteredEvents ?? [];

  return (
    <AffectedMeteredEventsTable
      items={affectedMeteredEvents}
      itemsCount={affectedMeteredEvents.length}
      loadingItems={isFetchingAffected}
    />
  );
};
